import React from 'react'
import Panel from 'muicss/lib/react/panel'
import Container from 'muicss/lib/react/container'
import { connect } from 'react-redux'
import ShowMissionStepper from './ShowMissionStepper'
import { missionAnswerInit } from '../../actions'


class MissionShow extends React.Component {

  componentDidMount = () =>
    this.props.missionAnswerInit()

  render() {
    const { name, mission_pages } = this.props
    return (
      <Container>
        <Panel className="modal-panel">
          <h1 style={{ textAlign: 'center' }}>{`${name}`}</h1>
          <ShowMissionStepper
            mission_pages={mission_pages}
          />
        </Panel>
      </Container>
    )
  }
}

MissionShow.propTypes = {
  name: React.PropTypes.string,
  mission_pages: React.PropTypes.arrayOf(React.PropTypes.shape({
    id: React.PropTypes.number,
  })),
}


const mapStateToProps = state => ({
  name: state.missions.selectedMission.name,
  mission_pages: [...state.missions.answerMission.progress.pages_to_answer],
})

const mapDispatchToProps = dispatch => ({
  missionAnswerInit: () => dispatch(missionAnswerInit()),
})


export default connect(mapStateToProps, mapDispatchToProps)(MissionShow)



// WEBPACK FOOTER //
// ./src/components/MissionShow/index.jsx